import { render, staticRenderFns } from "./SettingsCharts.vue?vue&type=template&id=2dcc274a&"
import script from "./SettingsCharts.vue?vue&type=script&lang=ts&"
export * from "./SettingsCharts.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsCharts.vue?vue&type=style&index=0&id=2dcc274a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports